var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageStartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.669,
    height: 86.666,
    viewBox: "0 0 86.669 86.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3902",
    "data-name": "Path 3902",
    d: "M-394.1,358.7h-36.982c-3.938,0-6.34-2.387-6.34-6.3q0-23.1,0-46.206a9.571,9.571,0,0,1,4.711-8.538c1.4-.893,2.813-1.769,4.249-2.6a1.807,1.807,0,0,1,2.271.172,1.76,1.76,0,0,1,.423,2.091,2.25,2.25,0,0,1-.824.9q-1.764,1.16-3.588,2.229a6.419,6.419,0,0,0-3.334,5.948q.007,19.549,0,39.1c0,2.285-.006,4.57,0,6.855.006,1.766.689,2.441,2.476,2.441q36.855,0,73.709,0c1.75,0,2.44-.657,2.441-2.384q.011-22.976.008-45.952a6.26,6.26,0,0,0-3.285-5.791c-1.142-.668-2.26-1.378-3.377-2.086a2.1,2.1,0,0,1-.858-2.844,2.08,2.08,0,0,1,2.91-.542c1.727,1.06,3.506,2.06,5.113,3.283a8.944,8.944,0,0,1,3.6,7.4q.035,23.4.009,46.8a5.794,5.794,0,0,1-6.021,6.027Q-375.437,358.71-394.1,358.7Z",
    transform: "translate(437.419 -272.039)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    "data-name": "Path 3903",
    d: "M-316.84,160.657q10.7,0,21.408,0a5.832,5.832,0,0,1,6.2,6.2q.008,14.469,0,28.939c0,1.683-1.133,2.641-2.587,2.193a1.7,1.7,0,0,1-1.308-1.581c-.029-.393-.029-.789-.029-1.184q0-13.962,0-27.923c0-2.136-.589-2.73-2.7-2.73h-41.885c-2.167,0-2.736.577-2.736,2.775q0,13.919,0,27.838c0,.366,0,.734-.021,1.1a1.784,1.784,0,0,1-1.775,1.779,1.865,1.865,0,0,1-2.1-1.636,5.482,5.482,0,0,1-.028-.844q0-14.258,0-28.515c0-4.035,2.376-6.408,6.412-6.408Z",
    transform: "translate(360.153 -160.657)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3904",
    "data-name": "Path 3904",
    d: "M-356.32,398.556a9.227,9.227,0,0,1-6.057-2.213q-14.16-11.666-28.36-23.285a1.9,1.9,0,0,1-.3-2.832,1.921,1.921,0,0,1,2.785-.182q13.761,11.289,27.511,22.59c1.394,1.148,2.8,2.166,4.722,2.152a6.109,6.109,0,0,0,3.953-1.455q14.05-11.534,28.123-23.041a3.09,3.09,0,0,1,1.749-.639,1.7,1.7,0,0,1,1.7,1.292,1.989,1.989,0,0,1-.786,2.171q-3.252,2.7-6.528,5.374-10.687,8.77-21.372,17.542A10.493,10.493,0,0,1-356.32,398.556Z",
    transform: "translate(399.303 -334.174)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3905",
    "data-name": "Path 3905",
    d: "M-284.88,370.061c3.524,0,7.049-.014,10.573.007,1.764.011,2.7,1.262,2.112,2.753a1.994,1.994,0,0,1-2.122,1.2c-2.82.007-5.639,0-8.458,0-4.2,0-8.4.009-12.6,0-1.588-.005-2.358-.823-2.221-2.287a1.678,1.678,0,0,1,1.476-1.6,6.746,6.746,0,0,1,1.094-.074Q-289.955,370.056-284.88,370.061Z",
    transform: "translate(321.282 -334.609)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3906",
    "data-name": "Path 3906",
    d: "M-29.862,550.567a5.8,5.8,0,0,1-5.861,5.924,5.807,5.807,0,0,1-5.9-5.965,5.757,5.757,0,0,1,5.9-5.863A5.76,5.76,0,0,1-29.862,550.567Zm-3.936.02a1.864,1.864,0,0,0-1.928-2,1.875,1.875,0,0,0-1.977,1.958,1.847,1.847,0,0,0,1.935,1.985A1.832,1.832,0,0,0-33.8,550.587Z",
    transform: "translate(108.626 -479.658)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3907",
    "data-name": "Path 3907",
    d: "M-286.862,280.83c-2.819,0-5.638.012-8.456-.005-1.7-.01-2.489-.845-2.3-2.375a1.651,1.651,0,0,1,1.22-1.461,3.111,3.111,0,0,1,.915-.141c5.75-.008,11.5-.021,17.25,0,1.663.007,2.513,1.088,2.13,2.572A1.623,1.623,0,0,1-277.4,280.7a6.452,6.452,0,0,1-1.256.121C-281.394,280.835-284.128,280.83-286.862,280.83Z",
    transform: "translate(321.304 -257.169)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3908",
    "data-name": "Path 3908",
    d: "M-168.422,558.312a9.873,9.873,0,0,1,1.519.946c1.623,1.462,3.332,1.479,4.83-.115a7.263,7.263,0,0,1,6.091-2.706,7.52,7.52,0,0,1,5.082,2.714,1.787,1.787,0,0,1-.09,2.269,1.709,1.709,0,0,1-2,.682,2.678,2.678,0,0,1-.741-.388c-2.559-1.968-3.4-1.923-5.675.323a7.017,7.017,0,0,1-10.488-.292,1.7,1.7,0,0,1-.363-2.019A2.276,2.276,0,0,1-168.422,558.312Z",
    transform: "translate(215.64 -489.419)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3909",
    "data-name": "Path 3909",
    d: "M-229.682,222.646c-2.567,0-5.134.019-7.7-.008-1.317-.014-2.013-.627-2.09-1.725a1.857,1.857,0,0,1,1.974-2.2q7.828-.038,15.655,0a1.831,1.831,0,0,1,2.012,1.913,1.788,1.788,0,0,1-1.981,2c-2.623.04-5.246.012-7.87.012Z",
    transform: "translate(272.987 -208.874)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3910",
    "data-name": "Path 3910",
    d: "M-139.611,280.828c-1.549,0-3.1.022-4.647-.008-1.375-.027-2.127-.689-2.185-1.841A1.818,1.818,0,0,1-144.8,276.9a3.834,3.834,0,0,1,.671-.062c3.042,0,6.084-.012,9.126,0,1.435.007,2.193.6,2.286,1.716a1.874,1.874,0,0,1-1.993,2.253c-.927.053-1.858.015-2.788.016Q-138.555,280.83-139.611,280.828Z",
    transform: "translate(195.704 -257.168)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3911",
    "data-name": "Path 3911",
    d: "M-198.641,327.52c-1.3,0-2.593.014-3.889,0a1.812,1.812,0,0,1-2-1.981,1.8,1.8,0,0,1,1.982-1.915q3.889-.019,7.778,0a1.831,1.831,0,0,1,2.012,1.983,1.814,1.814,0,0,1-2,1.912C-196.048,327.534-197.345,327.52-198.641,327.52Z",
    transform: "translate(243.953 -296.026)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3912",
    "data-name": "Path 3912",
    d: "M-291.781,327.514c-1.3,0-2.592.018-3.888,0a1.8,1.8,0,0,1-1.943-1.95,1.8,1.8,0,0,1,1.953-1.943q3.93-.022,7.86,0a1.8,1.8,0,0,1,1.945,1.953,1.794,1.794,0,0,1-1.955,1.939C-289.132,327.531-290.456,327.514-291.781,327.514Z",
    transform: "translate(321.278 -296.021)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    d: "M-107.568,327.457c-.7,0-1.409.025-2.111-.006a1.793,1.793,0,0,1-1.8-1.921,1.789,1.789,0,0,1,1.765-1.956q2.152-.06,4.307,0a1.778,1.778,0,0,1,1.75,1.965,1.776,1.776,0,0,1-1.8,1.913C-106.159,327.481-106.864,327.457-107.568,327.457Z",
    transform: "translate(166.654 -295.97)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M-14.548,569.841a1.832,1.832,0,0,1-1.969,1.943,1.847,1.847,0,0,1-1.935-1.985,1.875,1.875,0,0,1,1.977-1.958A1.864,1.864,0,0,1-14.548,569.841Z",
    transform: "translate(89.375 -498.912)",
    fill: "#d10a11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageStartIcon);
export default __webpack_public_path__ + "static/media/MessageStartIcon.8134ad56a704f7127929eccd479ddf54.svg";
export { ForwardRef as ReactComponent };